// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"AddNewGoalPop_AddNewGoalPop__JsmJ9","modalBody":"AddNewGoalPop_modalBody__QT4qL","formControl":"AddNewGoalPop_formControl__LYr3Y","add":"AddNewGoalPop_add__K8fb-"};